import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from "react-i18next";
var StatementsTrans = function (_a) {
    var i18nKey = _a.i18nKey, components = _a.components;
    return _jsx(Trans, { i18nKey: i18nKey, components: components });
};
export default StatementsTrans;
